// Product categories
export const CATEGORIES = ["Photography", "AI Art"];

// Available frame types
export const FRAME_TYPES = [
  "Canvas Print",
  "Stretched Canvas",
  "Framed Canvas",
];

// Available sizes
export const SIZES = ["50x20cm", "70x30cm", "90x45cm", "120x60cm", "150x75cm"];

// Default pricing structure — every combination set to 0 by default.
// Admin fills these in manually via the admin panel.
export const DEFAULT_PRICING = {
  "Canvas Print": {
    "50x20cm": 0,
    "70x30cm": 0,
    "90x45cm": 0,
    "120x60cm": 0,
    "150x75cm": 0,
  },
  "Stretched Canvas": {
    "50x20cm": 0,
    "70x30cm": 0,
    "90x45cm": 0,
    "120x60cm": 0,
    "150x75cm": 0,
  },
  "Framed Canvas": {
    "50x20cm": 0,
    "70x30cm": 0,
    "90x45cm": 0,
    "120x60cm": 0,
    "150x75cm": 0,
  },
};
